import React, { useEffect } from 'react'
import useAxios from 'axios-hooks'
import { useProgramContext } from 'providers/programProvider'
import { actions } from 'providers/programProvider/links/actions'

export const useLinks = () => {
  const [state, dispatch] = useProgramContext()

  const [{ data, loading }] = useAxios(
    { url: 'links' },
    { manual: !!state?.links }
  )

  useEffect(() => {
    dispatch(actions.loadingLinks(loading))
  }, [loading])

  useEffect(() => {
    if (!state?.links && data) {
      dispatch(actions.setLinks(data.data))
    }
  }, [data])
}
